import { useSelector } from 'react-redux';
import ManorShell from './ManorShell';

// "HH:MM:SS" -> "MM:SS" (thankyou.php folds the hours into minutes).
const toMmSs = (t = '00:00:00') => {
  const [h = 0, m = 0, s = 0] = t.split(':').map(Number);
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(h * 60 + m)}:${pad(s)}`;
};

export default function ManorThankyou() {
  const game = useSelector((s) => s.manor.game);
  return (
    <ManorShell bg="thankyoubg.png" stage="thankyou">
      <div className="manor-thankyou">
        <img src="/manor/img/thankyou.png" alt="Thank you" />
        <p>Congratulations! You have completed it in {game?.optimistic ? '…' : toMmSs(game?.time)} minutes.</p>
      </div>
    </ManorShell>
  );
}
